// VERSION : 0.0.1
// AUTHOR : VIGNESH
// LAST EDIT : VIGNESH
// MODIFIED DATE: 07-12-2025
// LAST CHANGED : ADDED COMMENT LINES

const MonthlyWiseInterestSummaryReportAction = {
	/*************** Get Month Wise Interest Summary Report STart ******************/
	GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_START:
		'get_month_wise_interest_summary_report_list_start',
	GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_SUCCESS:
		'get_month_wise_interest_summary_report_list_success',
	GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_FAILURE:
		'get_month_wise_interest_summary_report_list_failure',
	GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_RESPONSE_RESET:
		'get_month_wise_interest_summary_report_list_response_reset',
	GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_RESPONSE_CHANGED:
		'get_month_wise_interest_summary_report_list_response_changed',
	/*************** Get Month Wise Interest Summary Report End ******************/

	/*************** Get Month Wise Interest Summary Report Excel Start ******************/
	GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_START:
		'get_month_wise_interest_summary_report_excel_start',
	GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_SUCCESS:
		'get_month_wise_interest_summary_report_excel_success',
	GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_FAILURE:
		'get_month_wise_interest_summary_report_excel_failure',
	GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_RESPONSE_RESET:
		'get_month_wise_interest_summary_report_excel_response_reset',
	GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_RESPONSE_CHANGED:
		'get_month_wise_interest_summary_report_excel_response_changed',
	/*************** Get Month Wise Interest Summary Report Excel End ******************/
};
export default MonthlyWiseInterestSummaryReportAction;
